module.exports = __webpack_public_path__ + "static/media/earthy.4b898a2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/question-images/earthy.jpg
// module id = 146
// module chunks = 0